import React, { useState, useEffect } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Divider,
  Button,
  Grid,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
// استيراد شعار Hamam
import hamamLogo from "./../../Assets/Imgs/Main_Logo.png";

const AccoCodeModal = ({ 
  open, 
  onClose, 
  reservation,
  onAccept,
  onDecline,
  isLoading,
  modalType = "code" // "code" أو "paypal"
}) => {
  const [fullscreenImage, setFullscreenImage] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [images, setImages] = useState([]);

  // دالة لتنسيق التاريخ والوقت
  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    
    return `${hours}:${minutes} ${day}.${month}.${year}`;
  };

  // تحديث الصور عند تغيير الحجز أو نوع المودال
  useEffect(() => {
    if (reservation) {
      let imageList = [];
      
      if (modalType === "paypal" && reservation.paymentProofPhoto) {
        imageList = [reservation.paymentProofPhoto];
      } else if (modalType === "code") {
        // دعم البيانات الجديدة من الجدول
        if (reservation.imageData && reservation.imageData.images) {
          imageList = reservation.imageData.images;
        }
        // دعم الصور المتعددة الجديدة
        else if (reservation.codePhotos && Array.isArray(reservation.codePhotos) && reservation.codePhotos.length > 0) {
          imageList = reservation.codePhotos.map((photo, index) => {
            // إذا كانت الصورة عبارة عن string (URL مباشر)
            if (typeof photo === 'string') {
              return photo;
            } 
            // إذا كانت الصورة عبارة عن object مع url
            else if (photo && typeof photo === 'object' && photo.url) {
              return photo.url;
            } 
            // إذا كانت الصورة عبارة عن object مع خصائص أخرى
            else if (photo && typeof photo === 'object') {
              // تحقق من خصائص أخرى محتملة
              if (photo.secure_url) return photo.secure_url;
              if (photo.public_id) {
                // إنشاء URL من public_id
                const cloudinaryUrl = `https://res.cloudinary.com/dguqk7cs8/image/upload/${photo.public_id}`;
                return cloudinaryUrl;
              }
            }
            
            return null;
          }).filter(Boolean);
        }
        // دعم الصورة الواحدة القديمة
        else if (reservation.codePhoto) {
          let photoUrl;
          if (reservation.codePhoto.startsWith('http')) {
            photoUrl = reservation.codePhoto;
          } else {
            photoUrl = `${process.env.REACT_APP_API_URL}/${reservation.codePhoto}`;
          }
          
          imageList = [photoUrl];
        }
        
        // إضافة تشخيص إضافي
    
        console.log('  Final imageList for code:', imageList);
      }
      
      setImages(imageList);
      setCurrentImageIndex(0);
      console.log('✅ Images set in modal:', imageList);
    }
  }, [reservation, modalType]);

  const handleFullscreenToggle = () => {
    setFullscreenImage(!fullscreenImage);
  };

  const nextImage = () => {
    if (images.length > 1) {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }
  };

  const prevImage = () => {
    if (images.length > 1) {
      setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    }
  };
  
  // تحديد العنوان بناءً على نوع المودال
  const modalTitle = modalType === "paypal" 
    ? "PayPal Zahlungsnachweis" 
    : "Hochgeladener Gutschein";

  return (
    <>
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="sm" 
        fullWidth
        PaperProps={{
          sx: { 
            borderRadius: "12px",
            overflow: "hidden"
          }
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "#CD9D41",
            fontWeight: "bold",
            fontSize: "1.25rem",
            padding: "16px 24px",
            backgroundColor: "#f9f9f9"
          }}
        >
          <Typography sx={{ color: "#CD9D41", fontWeight: "bold" }}>
            {modalTitle}
          </Typography>
          <IconButton 
            onClick={onClose}
            sx={{
              "&:hover": {
                backgroundColor: "rgba(205, 157, 65, 0.1)"
              }
            }}
          >
            <CloseIcon sx={{ color: "#CD9D41" }} />
          </IconButton>
        </DialogTitle>

        <Divider sx={{ backgroundColor: "#CD9D41", height: "2px" }} />

        <DialogContent sx={{ py: 4, px: 3 }}>
          {/* معلومات الحجز */}
          {reservation && (
            <Box sx={{ 
              mb: 3, 
              p: 3, 
              backgroundColor: '#f8f9fa', 
              borderRadius: '8px',
              border: '1px solid #e9ecef'
            }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#CD9D41' }}>
                Reservierungsdetails
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', mb: 0.5 }}>
                    Buchungsnummer:
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#666', mb: 1.5 }}>
                    {reservation.reservationNumber || 'N/A'}
                  </Typography>
                  
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', mb: 0.5 }}>
                    Kundenname:
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#666', mb: 1.5 }}>
                    {reservation.customerName || reservation.userName || 'N/A'}
                  </Typography>
                  
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', mb: 0.5 }}>
                    E-Mail:
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#666', mb: 1.5 }}>
                    {reservation.customerEmail || 'N/A'}
                  </Typography>
                  
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', mb: 0.5 }}>
                    Telefon:
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#666', mb: 1.5 }}>
                    {reservation.customerPhone || 'N/A'}
                  </Typography>
                </Grid>
                
                <Grid item xs={6}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', mb: 0.5 }}>
                    Reservierungsdatum:
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#666', mb: 1.5 }}>
                    {formatDateTime(reservation.dateOfReservation)}
                  </Typography>
                  
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', mb: 0.5 }}>
                    Enddatum der Reservierung:
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#666', mb: 1.5 }}>
                    {formatDateTime(reservation.dateEndOfReservation)}
                  </Typography>
                  
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', mb: 0.5 }}>
                    Zahlungsart:
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#666', mb: 1.5 }}>
                    {reservation.payWay === 'paypal' ? 'PayPal' : 
                     reservation.payWay === 'code' ? 'Gutschein' : 
                     reservation.payWay === 'special' ? 'Spezial' : 'N/A'}
                  </Typography>
                  
                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', mb: 0.5 }}>
                    Status:
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#666', mb: 1.5 }}>
                    {reservation.status === 'accepted' ? 'Angenommen' : 
                     reservation.status === 'rejected' ? 'Abgelehnt' : 
                     reservation.status === 'pending' ? 'Ausstehend' : 'N/A'}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            mb: 4,
            border: '1px solid #eee',
            borderRadius: '8px',
            padding: '16px',
            position: 'relative'
          }}>
            {images.length > 0 ? (
              <Box sx={{ position: 'relative', width: '100%', maxWidth: '500px' }}>
                {/* عرض عدد الصور */}
                {images.length > 1 && (
                  <Typography 
                    sx={{ 
                      textAlign: 'center', 
                      mb: 2, 
                      color: '#CD9D41', 
                      fontWeight: 'bold' 
                    }}
                  >
                    {modalType === "paypal" ? "PayPal Zahlungsnachweis" : "Hochgeladene Gutscheine"} ({images.length} Bilder)
                  </Typography>
                )}
                
                <Box sx={{ position: 'relative' }}>
                <img
                src={images[currentImageIndex]}
                    alt={`${modalType === "paypal" ? "PayPal Zahlungsnachweis" : "Gutschein"} ${currentImageIndex + 1}`} 
                    style={{ 
                      width: '100%', 
                      height: '400px', // زيادة ارتفاع لعرض أفضل
                      objectFit: "contain",
                      borderRadius: '8px',
                      backgroundColor: '#f8f9fa', // خلفية فاتحة
                      border: '1px solid #dee2e6' // حدود خفيفة
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      // يمكن إضافة عنصر بديل هنا
                    }}
                    loading="eager" // تحميل فوري للصور في النافذة المنبثقة
                  />
                  
                  {/* أزرار التنقل للصور المتعددة */}
                  {images.length > 1 && (
                    <>
                      <IconButton
                        onClick={prevImage}
                        sx={{
                          position: 'absolute',
                          left: 8,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          bgcolor: 'rgba(0,0,0,0.5)',
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                        }}
                      >
                        <ChevronLeft />
                      </IconButton>
                      
                      <IconButton
                        onClick={nextImage}
                        sx={{
                          position: 'absolute',
                          right: 8,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          bgcolor: 'rgba(0,0,0,0.5)',
                          color: 'white',
                          '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                        }}
                      >
                        <ChevronRight />
                      </IconButton>
                      
                      <Box sx={{
                        position: 'absolute',
                        bottom: 8,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        bgcolor: 'rgba(0,0,0,0.7)',
                        color: 'white',
                        px: 2,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: '14px'
                      }}>
                        {currentImageIndex + 1} / {images.length}
                      </Box>
                    </>
                  )}
                </Box>
                
                <Button
                  variant="contained"
                  onClick={handleFullscreenToggle}
                  sx={{
                    mt: 2,
                    backgroundColor: "#CD9D41",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#b88a30",
                    },
                    borderRadius: "8px",
                    px: 3,
                    py: 1,
                    fontSize: "0.875rem",
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                  }}
                >
                  <FullscreenIcon fontSize="small" />
                  Vollbild anzeigen
                </Button>
              </Box>
            ) : (
              <Box sx={{
                width: '100%', 
                maxWidth: '500px',
                height: '300px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '2px dashed #ddd'
              }}>
                <Box 
                  component="div"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    textAlign: 'center'
                  }}
                >
                  <img 
                    src={hamamLogo} 
                    alt="Hamam Wuppertal Logo" 
                    style={{ 
                      width: '200px',
                      objectFit: 'contain',
                      opacity: 0.8
                    }} 
                  />
                  <Typography 
                    variant="h6" 
                    color="text.secondary"
                    sx={{ 
                      textAlign: 'center',
                      fontWeight: 'bold',
                      color: '#CD9D41',
                      mt: 2
                    }}
                  >
                    {modalType === "paypal" ? "Kein Zahlungsnachweis verfügbar" : "Kein Gutscheinbild verfügbar"}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{ 
                      textAlign: 'center',
                      color: '#999',
                      maxWidth: '350px',
                      mt: 1
                    }}
                  >
                    {/* {modalType === "paypal" 
                      ? "Es wurde kein Bild als Zahlungsnachweis für diese PayPal-Zahlung hochgeladen." 
                      : "Es wurde kein Gutscheinbild für diese Reservierung hochgeladen."} */}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>

          {/* أزرار الإجراءات - تظهر دائماً */}
          <Box 
            display="flex" 
            justifyContent="center" 
            gap={3}
            sx={{
              mt: 3,
              pt: 2,
              borderTop: '1px solid #eee'
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                if (onDecline && typeof onDecline === 'function') {
                  onDecline();
                }
              }}
              disabled={isLoading}
              sx={{
                backgroundColor: "#C03C3C",
                color: "#FFFFFF",
                fontWeight: "bold",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#a03030",
                },
                "&:disabled": {
                  backgroundColor: "#ccc",
                  color: "#666"
                },
                borderRadius: "8px",
                px: 4,
                py: 1.5,
                fontSize: "0.875rem",
                minWidth: "160px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}
            >
              {isLoading ? "Wird bearbeitet..." : modalType === "paypal" 
                ? "Zahlung ablehnen" 
                : "Reservierung ablehnen"}
            </Button>
            
            <Button
              variant="contained"
              onClick={() => {
                if (onAccept && typeof onAccept === 'function') {
                  onAccept();
                }
              }}
              disabled={isLoading}
              sx={{
                backgroundColor: "#36D06A",
                color: "#FFFFFF",
                fontWeight: "bold",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#2bb359",
                },
                "&:disabled": {
                  backgroundColor: "#ccc",
                  color: "#666"
                },
                borderRadius: "8px",
                px: 4,
                py: 1.5,
                fontSize: "0.875rem",
                minWidth: "160px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}
            >
              {isLoading ? "Wird bearbeitet..." : modalType === "paypal" 
                ? "Zahlung bestätigen" 
                : "Reservierung annehmen"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {images.length > 0 && (
        <Dialog
          open={fullscreenImage}
          onClose={handleFullscreenToggle}
          maxWidth={false}
          fullScreen
          PaperProps={{
            sx: { 
              bgcolor: 'black',
              boxShadow: 'none',
            }
          }}
        >
          <IconButton
            onClick={handleFullscreenToggle}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.7)'
              },
              zIndex: 10
            }}
          >
            <CloseIcon />
          </IconButton>
          
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              width: '100vw',
              position: 'relative'
            }}
          >
            <img
              src={images[currentImageIndex]}
              alt={`${modalType === "paypal" ? "PayPal Zahlungsnachweis" : "Gutschein"} ${currentImageIndex + 1} Vollbild`}
              style={{
                height: '100vh',
                maxWidth: '100vw',
                objectFit: 'contain'
              }}
            />
            
            {/* أزرار التنقل في وضع الشاشة الكاملة */}
            {images.length > 1 && (
              <>
                <IconButton
                  onClick={prevImage}
                  sx={{
                    position: 'absolute',
                    left: 32,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' },
                    width: 56,
                    height: 56
                  }}
                >
                  <ChevronLeft fontSize="large" />
                </IconButton>
                
                <IconButton
                  onClick={nextImage}
                  sx={{
                    position: 'absolute',
                    right: 32,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' },
                    width: 56,
                    height: 56
                  }}
                >
                  <ChevronRight fontSize="large" />
                </IconButton>
                
                <Box sx={{
                  position: 'absolute',
                  bottom: 32,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  bgcolor: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  px: 3,
                  py: 1,
                  borderRadius: 2,
                  fontSize: '18px'
                }}>
                  {currentImageIndex + 1} / {images.length}
                </Box>
              </>
            )}
          </Box>
        </Dialog>
      )}
    </>
  );
};

export default AccoCodeModal;
